// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/ddt/mall/js/" + chunkId + "." + {"818":"ad1b436e","923":"876ba84e"}[chunkId] + ".js";
};